/* ──────────────────────────────────────────────────────────────────────────────
   NAMA SEVK BELGELERİ — ortak katman (liste + detay)

   ══ BU BELGE BİZİM DEĞİLDİR ═══════════════════════════════════════════════════
   Tüccar plasiyer bu belgeyi SÜTAŞ ADINA taşır ve teslim eder. Satıcı HER ZAMAN
   Sütaş'tır; belge SAP'de (ya da telsel'de) doğar, SAP'de faturalaşır. Bizim
   faturamız/siparişimiz DEĞİLDİR → Fatura/Sipariş ekranlarına karıştırılmaz:
   karıştırılsaydı Sütaş'ın satışı bizim cirumuza, müşterinin Sütaş'a olan borcu
   bizim cari defterimize girerdi.

   Bu yüzden ekranlarda tutar GÖSTERİLİR ama "bizim tutarımız" gibi sunulmaz;
   satıcı bandı her iki ekranda da satıcının Sütaş olduğunu söyler.

   Backend: DataScope.Api/Controllers/NamaDocumentsController.cs
            DataScope.Entities/Static/NamaDeliveryStatuses.cs (+ Sources/DocTypes/ShortageReasons)
   ────────────────────────────────────────────────────────────────────────────── */

export const NAMA_API = '/api/nama-documents';

/* ── DURUM ─────────────────────────────────────────────────────────────────────
   Backend'de STRING'dir (int değil) → OData filtresi tırnaklı yazılır
   (`valueFormat: 'string'` → `Status eq 'DELIVERED'`). */
export const NAMA_STATUS = {
  PENDING_DELIVERY: 'PENDING_DELIVERY',
  IN_PROGRESS: 'IN_PROGRESS',
  PARTIAL: 'PARTIAL',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
};

const STATUS_META = {
  PENDING_DELIVERY: { label: 'Teslim Bekliyor', tone: 'wait' },
  IN_PROGRESS: { label: 'Teslim Ediliyor', tone: 'wait' },
  PARTIAL: { label: 'Kısmi Teslim', tone: 'wait' },
  DELIVERED: { label: 'Teslim Edildi', tone: 'ok' },
  CANCELLED: { label: 'İptal', tone: 'bad' },
};

export const statusLabel = (v) => STATUS_META[String(v || '')]?.label || '-';
export const statusTone = (v) => STATUS_META[String(v || '')]?.tone || 'neutral';

/** c360 huni seçenekleri — "Tümü" satırı YOKTUR (huninin kendi Temizle'si o işi görür). */
export const STATUS_SELECT_OPTIONS = Object.entries(STATUS_META)
  .map(([value, m]) => ({ value, label: m.label }));

/** Belge hâlâ açık mı — teslim edilmiş/iptal edilmiş belgede aksiyon alınamaz. */
export const isOpen = (v) => [NAMA_STATUS.PENDING_DELIVERY, NAMA_STATUS.IN_PROGRESS, NAMA_STATUS.PARTIAL]
  .includes(String(v || ''));
export const isClosed = (v) => [NAMA_STATUS.DELIVERED, NAMA_STATUS.CANCELLED].includes(String(v || ''));

/* ── KAYNAK ────────────────────────────────────────────────────────────────────
   Kaynak yalnız GÖSTERİM ayrımıdır, davranışı değiştirmez: SAP'den gelen de
   telsel'den gelen de aynı teslim akışıyla işlenir (backend NamaDeliverySources). */
export const NAMA_SOURCE = { SAP: 'SAP', TELSEL: 'TELSEL', MOBILE: 'MOBILE' };

const SOURCE_META = {
  SAP: { label: 'SAP', color: '#2563eb', bg: 'rgba(37,99,235,0.10)' },
  TELSEL: { label: 'Telsel', color: '#7c3aed', bg: 'rgba(124,58,237,0.10)' },
  MOBILE: { label: 'Mobil', color: '#0f766e', bg: 'rgba(15,118,110,0.10)' },
};

export const sourceLabel = (v) => SOURCE_META[String(v || '')]?.label || '-';
export const sourceStyle = (v) => {
  const m = SOURCE_META[String(v || '')];
  return {
    display: 'inline-flex', alignItems: 'center', padding: '2px 8px', borderRadius: 999,
    fontSize: 11, fontWeight: 800, letterSpacing: 0.2,
    color: m?.color || 'var(--text-secondary, #6b7280)',
    background: m?.bg || 'rgba(15,23,42,0.06)',
  };
};

export const SOURCE_SELECT_OPTIONS = Object.entries(SOURCE_META)
  .map(([value, m]) => ({ value, label: m.label }));

/* Back-office'ten AÇILAN belgede kaynak yalnız SAP veya TELSEL olabilir.
   MOBILE seçeneği YOKTUR: o, belgenin temsilcinin CİHAZINDA doğduğunun işaretidir —
   masabaşından "mobilden gelmiş" demek belgenin nereden geldiğini yalan söylemek olur.
   (Backend de reddeder: NamaDocumentsController.Create → 400.) */
export const SOURCE_CREATE_OPTIONS = [NAMA_SOURCE.SAP, NAMA_SOURCE.TELSEL]
  .map((value) => ({ value, label: SOURCE_META[value].label }));

/* ── BELGE TİPİ ───────────────────────────────────────────────────────────────── */
const DOC_TYPE_META = { SIPARIS: 'Sipariş', IRSALIYE: 'İrsaliye' };
export const docTypeLabel = (v) => DOC_TYPE_META[String(v || '')] || '-';
export const DOC_TYPE_SELECT_OPTIONS = Object.entries(DOC_TYPE_META)
  .map(([value, label]) => ({ value, label }));

/* ── EKSİK TESLİM GEREKÇESİ ────────────────────────────────────────────────────
   Teslim < sipariş ise ZORUNLUDUR (backend de reddeder): eksik teslimin sebebi
   kayda geçmezse ne stok sorunu ne de müşteri reddi sonradan ayırt edilebilir. */
export const SHORTAGE_REASONS = {
  stok_yok: 'Stok yok',
  musteri_istemedi: 'Müşteri istemedi',
  hasarli: 'Hasarlı',
};
export const shortageLabel = (v) => SHORTAGE_REASONS[String(v || '')] || '-';
export const SHORTAGE_OPTIONS = [
  { value: '', label: 'Gerekçe seçin…' },
  ...Object.entries(SHORTAGE_REASONS).map(([value, label]) => ({ value, label })),
];
export const isValidShortageReason = (v) => Object.keys(SHORTAGE_REASONS).includes(String(v || ''));

/* ── SATICI BANDI ──────────────────────────────────────────────────────────────
   Ekranın her yerinde aynı cümle: bu belgenin satıcısı BİZ DEĞİLİZ. */
export const DEFAULT_SELLER_NAME = 'Sütaş A.Ş.';
export const sellerNameOf = (header) => header?.sellerName || DEFAULT_SELLER_NAME;
export const SELLER_STATEMENT = 'Satıcı Sütaş\'tır — bu belge bizim faturamız/siparişimiz DEĞİLDİR.';

/* Yeni belge formunda satıcı SEÇİLMEZ — sunucu onu temsilcinin carisinden (Representative.VendorId)
   belirler. Seçtirseydik masabaşı kullanıcı belgeyi başka bir satıcının adına açabilirdi. */
export const SELLER_SERVER_DETERMINED = 'Satıcı seçilmez — sunucu belirler (temsilcinin carisinden).';

/* ── HESAP ─────────────────────────────────────────────────────────────────────
   Kalem tutarı teslim edilen miktardan hesaplanır; henüz teslim yoksa sipariş
   miktarı üzerinden gösterilir (belge daha teslim edilmemiştir). */
export const toNum = (v) => {
  const n = Number(String(v ?? '').replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};

export function lineAmount(line, deliveredOverride) {
  const qty = deliveredOverride === undefined || deliveredOverride === null || deliveredOverride === ''
    ? (line?.deliveredQuantity ?? line?.orderedQuantity ?? 0)
    : deliveredOverride;
  return toNum(qty) * toNum(line?.unitPrice);
}
